module.exports = __webpack_public_path__ + "static/media/aam-spiritual.d6fb1af0.jpg";